import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Box } from '@mui/material';
import Header from './components/Header';
import Footer from './components/Footer';
import Contact from './pages/Contact';
import Home from './pages/Home';
import Schedule from './pages/Schedule';
import Admin from './pages/Admin';
import AppointmentConfirmation from './pages/AppointmentConfirmation';
import Legal from './pages/Legal';
import Promotions from './pages/Promotions';

function App() {
  return (
    <Box sx={{ 
      minHeight: '100vh', 
      display: 'flex', 
      flexDirection: 'column',
      backgroundColor: 'background.default'
    }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/schedule" element={<Schedule />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/appointment" element={<AppointmentConfirmation />} />
          <Route path="/legal" element={<Legal />} />
          <Route path="/promotions/:id" element={<Promotions />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
    </Box>
  );
}

export default App;
